import axiosClient from './axiosClient';
const NhomQuyenApi = {
    getAll: () => {
        const url = '/role';
        return axiosClient.get(url);
    },

    getPaging: (params) => {
        const url = '/role/paging';
        return axiosClient.get(url, {params});
    },

    getDetail: (id) =>{
        const url = '/role/' + id;
        return axiosClient.get(url);
    },

    post: (data) =>{
        const url = '/role';
        return axiosClient.post(url, data);
    },

    put: (data) => {
        const url = '/role';
        return axiosClient.put(url, data);
    },

    delete: (id) =>{
        const url = '/role/' + id;
        return axiosClient.delete(url);
    }
}
export default NhomQuyenApi;